const GET_ENROLLMENT_HISTORY: string = 'GET_ENROLLMENT_HISTORY';
const GET_ENROLLMENT_HISTORY_ERROR: string = 'GET_ENROLLMENT_HISTORY_ERROR';

export const ENROLLMENT_HISTORY_ACTION_TYPES = {
    GET_ENROLLMENT_HISTORY,
    GET_ENROLLMENT_HISTORY_ERROR
};